import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import Section from '../shared/Section/Section';
import Container from '../shared/Container/Container';
import './Solution.css';

const Solution = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <Section background="beige">
      <Container>
        <div className="solution" ref={ref}>
          <div className="solution__content">
            <motion.div
              className="solution__text"
              initial={{ opacity: 0, x: -50 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8 }}
            >
              <h2 className="solution__title">
                The Only Elongated Sauce Cup Made for Full-Rib Dunking
              </h2>
              <p className="solution__description">
                No more juggling or spooning BBQ sauce onto your ribs. Just dip, coat, and bite. Our revolutionary elongated sauce cup design gives every rib complete sauce coverage and its moment of glory. Perfect for BBQ restaurants, food trucks, catering services, and home grilling enthusiasts.
              </p>
            </motion.div>

            <motion.div
              className="solution__image"
              initial={{ opacity: 0, x: 50 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              {/* Image: product_clean_angle.jpg */}
              {/* Prompt: A studio product shot of a rib-shaped sauce cup on a white background, subtle reflections, minimalist lighting showing the contours and rib shape clearly. */}
              <img
                src="/images/product_clean_angle.jpg"
                alt="Rib-n-Dip custom elongated BBQ sauce cup product shot - rib-shaped container for restaurants"
                className="solution__image-main"
                loading="lazy"
              />
            </motion.div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default Solution;
